// JOBE-0044.6: LibraryRail — left-column host. Stacks the three rail
// blocks top to bottom: SavedViewsBlock, TypeRailBlock,
// CollectionsRailBlock. Each block resolves independently per R9 /
// "render incrementally"; no global rail spinner.

import { SavedViewsBlock } from './SavedViewsBlock.jsx';
import { TypeRailBlock } from './TypeRailBlock.jsx';
import { CollectionsRailBlock } from './CollectionsRailBlock.jsx';

export function LibraryRail({
  activeView,
  activeType,
  principalUrn,
  typeRail,
  onChangeTypeRail,
  onPickView,
  onPickType,
  onPickCollection,
  // JOBE-0044.9: chip set captured at save time + on-success callback
  // so the page can re-anchor `?view=<slug>` to the freshly-saved view.
  // `createOpen` lets the omni palette's ⌘↩ chord open the same modal
  // the rail's "+ Save view" button opens.
  currentChips,
  onAfterSaveCurrentView,
  createOpen,
  onCreateModalClose,
}) {
  return (
    <div className="library-rail-stack">
      <SavedViewsBlock
        activeView={activeView}
        onPickView={onPickView}
        principalUrn={principalUrn}
        currentChips={currentChips}
        onAfterSaveCurrentView={onAfterSaveCurrentView}
        createOpen={createOpen}
        onCreateModalClose={onCreateModalClose}
      />
      <TypeRailBlock
        activeType={activeType}
        onPickType={onPickType}
        typeRail={typeRail}
        onChangeTypeRail={onChangeTypeRail}
      />
      <CollectionsRailBlock onPickCollection={onPickCollection} />
    </div>
  );
}
